<div class="u-card u-card--float">
	<p class="u-title">{{ 'NO_ACCESS.TITLE' | translate }}</p>
	<hr class="u-m-top--sm u-m-bottom--sm" />
	<div [innerHTML]="'NO_ACCESS.CONTENT' | translate: { url: RRN_APP_URL }"></div>

	<a [routerLink]="['/', 'offers', id]" class="back-btn u-text--medium u-m-top--sm">
		<tvcore-icon name="arrow"></tvcore-icon>
		{{ 'NO_ACCESS.BACK_BUTTON' | translate }}
	</a>
</div>
